
<input type="checkbox" #inputElement
	[id]="widget.uid"
	[(ngModel)]="checked"
	[hisDdKey]="widget.label"
	[hisDdSearchCriterion]="true"
    (change)="change()">
<label [for]="widget.uid" aria-hidden="false">
	{{widget.label | hisUi}}
</label>
